import React from 'react'

import Stepper from '../../../../../../common/inputs/stepper/Stepper'
import { FieldProps } from '../../../../../../../@types/types'
import { WhoWeLookForScreenValidationResult } from '../../../../../../../@types/validation-types'

const FlatShareSize: React.FC<FieldProps<WhoWeLookForScreenValidationResult>> = ({
  validationMessages,
  insertionData,
  screenName,
  onChange,
}) => (
  <div className='margin-top-m'>
    <Stepper
      id='flat-share-size'
      propertyName='flatShareSize'
      placeholder=''
      label='wizard.screen.whoWeLookFor.flatShareSize'
      input={insertionData.flatShareSize}
      type='tel'
      maxLength={2}
      max={11}
      min={2}
      errors={validationMessages!.flatShareSize ?? []}
      doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
    />
  </div>
)

export default FlatShareSize
